import { Heading, Img } from "./..";
import { Link } from "react-router-dom";
import { MyProfile} from "components/MyProfile";

import React from "react";

export default function Header2({onMenuClick, isAuthenticated, ...props }) {
  return (
    <header
      {...props}
      className={`${props.className} flex sm:flex-col justify-between items-center gap-5 px-[22px] py-[18px] sm:px-5 bg-black-900`}
    >
      <base href='/' />
      <button onClick={onMenuClick}>
        <Img src="images/img_megaphone.svg" alt="Megaphone Image" className="h-[28px] md:w-full" />
      </button>

      <ul className="flex flex-wrap gap-[100px] md:gap-4">
        {/* Home */}
        <li>
          <Link to="/home" className="cursor-pointer">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              HOME
            </Heading>
          </Link>
        </li>

        {/* about */}
        <li>
          <Link to="/about" className="cursor-pointer">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              ABOUT
            </Heading>
          </Link>
        </li>
        
        {/* Risk Model */}
        <li>
          <Link to="/RiskModel" className="cursor-pointer">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              RISK MODEL
            </Heading>
          </Link>
        </li>


        {/* Solutions */}
          <li>
          <Link to="/solutions" className="cursor-pointer">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              SOLUTIONS
            </Heading>
          </Link>
        </li>



        {/* DASHBOARD */}
        <li>
          <Link to="/dashboard">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              DASHBOARD
            </Heading>
          </Link>
        </li>
        {/* PRICING */}
        <li>
          <Link to="/BetaVersion" className="cursor-pointer">
            <Heading size="textmd" as="p" className="text-[16px] font-medium text-gray-300 hover:underline">
              BETA VERSION
            </Heading>
          </Link>
        </li>
        {/* Login/Logout */}
        <li> <a href="#" className="cursor-pointer">
              {<MyProfile />}     
             </a>
        </li>
      </ul>
    </header>
  );
}

 

